import {
  EVENT_NAME_FAIL,
  EVENT_NAME_REQUEST,
  EVENT_NAME_SUCCESS,
  UNIVERSITY_ATTENDED_COUNT_FAILED,
  UNIVERSITY_ATTENDED_COUNT_REQ,
  UNIVERSITY_ATTENDED_COUNT_SUCCESS,
  UNIVERSITY_COUNT_FAILED,
  UNIVERSITY_COUNT_REQ,
  UNIVERSITY_COUNT_SUCCESS,
} from "../constants/eventConstants";

export const eventNameReducer = (state = { eventTitle: "" }, action) => {
  switch (action.type) {
    case EVENT_NAME_REQUEST:
      return { loading: true };
    case EVENT_NAME_SUCCESS:
      return { loading: false, eventTitle: action.payload };
    case EVENT_NAME_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const UniversityCountReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case UNIVERSITY_COUNT_REQ: {
      return { loading: true };
    }

    case UNIVERSITY_COUNT_SUCCESS: {
      return { loading: false, University_Count: payload };
    }

    case UNIVERSITY_COUNT_FAILED: {
      return { loading: false, error: payload };
    }
    default:
      return state;
  }
};

export const AttendedStuentCountReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case UNIVERSITY_ATTENDED_COUNT_REQ: {
      return { loading: true };
    }

    case UNIVERSITY_ATTENDED_COUNT_SUCCESS: {
      return { loading: false, attendedCount: payload };
    }

    case UNIVERSITY_ATTENDED_COUNT_FAILED: {
      return { laoding: false, error: payload };
    }
    default:
      return state;
  }
};
